module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av240-5a8ca0c561a65c4ef021e72de6ef1e52.jpg";